import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: '<error-404></error-404>',
    templateUrl: './pagenotfound.component.html'
})
export class PageNotFoundComponent {

}